import {useLayoutEffect} from "react"

function useLockBodyScroll() {
  useLayoutEffect(() => {
    const body = document.body
    body.style.overflow = "hidden"

    return () => {body.style.removeProperty(`overflow`)}
  }, [])
}

export default useLockBodyScroll
